__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function() {

	};
	var uniqueName = "web-dashboard";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@setel/portal-ui", "7.8.0", function() { return Promise.all([__webpack_require__.e(424), __webpack_require__.e(470), __webpack_require__.e(950), __webpack_require__.e(181), __webpack_require__.e(372)]).then(function() { return function() { return __webpack_require__(76923); }; }); });
			register("@setel/web-variable-client-sdk", "0.2.1", function() { return Promise.all([__webpack_require__.e(902), __webpack_require__.e(950)]).then(function() { return function() { return __webpack_require__(53902); }; }); });
			register("date-fns", "2.29.3", function() { return Promise.all([__webpack_require__.e(749), __webpack_require__.e(960), __webpack_require__.e(290)]).then(function() { return function() { return __webpack_require__(31960); }; }); });
			register("formik", "2.2.9", function() { return Promise.all([__webpack_require__.e(952), __webpack_require__.e(577), __webpack_require__.e(950)]).then(function() { return function() { return __webpack_require__(69577); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(935), __webpack_require__.e(950)]).then(function() { return function() { return __webpack_require__(73935); }; }); });
			register("react-query", "3.24.4", function() { return Promise.all([__webpack_require__.e(767), __webpack_require__.e(950), __webpack_require__.e(181), __webpack_require__.e(413)]).then(function() { return function() { return __webpack_require__(88767); }; }); });
			register("react-redux", "7.2.5", function() { return Promise.all([__webpack_require__.e(216), __webpack_require__.e(950), __webpack_require__.e(181), __webpack_require__.e(101)]).then(function() { return function() { return __webpack_require__(28216); }; }); });
			register("react-router-dom", "5.3.0", function() { return Promise.all([__webpack_require__.e(338), __webpack_require__.e(950), __webpack_require__.e(939)]).then(function() { return function() { return __webpack_require__(23338); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(294).then(function() { return function() { return __webpack_require__(67294); }; }); });
			register("yup", "0.29.3", function() { return Promise.all([__webpack_require__.e(952), __webpack_require__.e(961), __webpack_require__.e(834)]).then(function() { return function() { return __webpack_require__(78961); }; }); });
			initExternal(93703);
			initExternal(90631);
			initExternal(39105);
			initExternal(66807);
			initExternal(26314);
			initExternal(6106);
			initExternal(78930);
			initExternal(68598);
			initExternal(80757);
			initExternal(85264);
			initExternal(73842);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};